import { render } from "./UserPasswordUpdatePage.vue?vue&type=template&id=78fc00aa&scoped=true"
import script from "./UserPasswordUpdatePage.vue?vue&type=script&lang=js"
export * from "./UserPasswordUpdatePage.vue?vue&type=script&lang=js"

import "./UserPasswordUpdatePage.vue?vue&type=style&index=0&id=78fc00aa&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fc00aa"]])

export default __exports__